export const messages = {
  en: {
    reportCustomComponent: {
      search: {
        title: 'Search Conditions',
        componentId: 'Please enter component ID',
        name: 'Please enter component name',
        componentType: 'Please select component type'
      },
      list: {
        title: 'Report Components'
      },
      table: {
        componentId: 'Component ID',
        name: 'Component Name',
        componentType: 'Component Type',
        queryModel: 'Query Method',
        remark: 'Description'
      },
      button: {
        setCondition: 'Set Condition',
        setFooter: 'Set Footer'
      },
      type: {
        table: 'Table',
        pie: 'Pie Chart',
        input: 'Input',
        select: 'Select',
        date: 'Date'
      },
      fetchError: 'Failed to get report components'
    }
  },
  zh: {
    reportCustomComponent: {
      search: {
        title: '查询条件',
        componentId: '请输入组件ID',
        name: '请输入组件名称',
        componentType: '请选择组件类型'
      },
      list: {
        title: '报表组件'
      },
      table: {
        componentId: '组件ID',
        name: '组件名称',
        componentType: '组件类型',
        queryModel: '查询方式',
        remark: '描述'
      },
      button: {
        setCondition: '设置条件',
        setFooter: '底部统计'
      },
      type: {
        table: '表格',
        pie: '饼状图',
        input: '输入框',
        select: '下拉框',
        date: '日期'
      },
      fetchError: '获取报表组件失败'
    }
  }
}